export const server = "https://driveserver.appdeploy.in/api/v1";
// export const server = "http://103.189.80.5:5657/api/v1";

